module.exports = __webpack_public_path__ + "static/media/NT_ThaiDuong.6da453d3.jpg";